
import clienteAxios from "../config/axios";

export const getAllHerramienta = async () => {
    return clienteAxios.get('/herramienta');
};
export const addHerramienta = async (herramienta) => {
    return await clienteAxios.post('/herramienta',{herramienta});
}
export const updateHerramienta = async (herramienta) => {
    return await clienteAxios.put(`herramienta/${herramienta.id}`,{herramienta});
}
export const deleteHerramienta = async (herramientaID,tDocID) => {
    return await clienteAxios.delete(`herramienta/${herramientaID}`,{data: {tDocID:tDocID}});
}
